module.exports = __webpack_public_path__ + "media/images/landing/persons/lucie-sumova-d6943bababd5666365c81b6fb5d3ff30.jpg";